module.exports = __webpack_public_path__ + "img/c21.e291baeb.png";